import { useState } from 'react';
import { useAuth } from '@/auth/AuthContext';
import { Icon } from '@/components/Icon';

/**
 * Pas ostrzegawczy widoczny, gdy administrator pracuje na cudzym koncie.
 *
 * Świadomie krzykliwy i nie do zamknięcia: portal wygląda wtedy dokładnie jak konto
 * użytkownika (bo takie są uprawnienia sesji), więc jedynym sygnałem „to nie Twoje konto"
 * jest ten baner. Każdy zapis w tym trybie zostanie zapisany na konto użytkownika,
 * a w audycie jako wykonany przez administratora.
 */
export function ImpersonationBanner() {
  const { impersonation, user, zakonczImpersonacje } = useAuth();
  const [wychodze, setWychodze] = useState(false);
  const [blad, setBlad] = useState<string | null>(null);

  if (!impersonation) return null;

  const wroc = async () => {
    setWychodze(true);
    setBlad(null);
    try {
      await zakonczImpersonacje();
      // Twarde przeładowanie: dane wielu widoków są już wczytane pod uprawnienia użytkownika
      // docelowego, a po powrocie muszą zostać pobrane na nowo dla konta administratora.
      window.location.assign('/admin/uzytkownicy');
    } catch (e) {
      setWychodze(false);
      setBlad((e as { body?: { message?: string } }).body?.message
        ?? 'Nie udało się wrócić na swoje konto. Wyloguj się i zaloguj ponownie.');
    }
  };

  return (
    <div className="bg-amber-100 border-b-2 border-amber-400 text-amber-900 px-4 sm:px-6 py-2
                    flex items-center gap-3 flex-wrap"
         role="status" aria-live="polite">
      <Icon name="eye" className="shrink-0 text-amber-700" />
      <div className="text-[13px] min-w-0 flex-1">
        <span className="font-semibold">Pracujesz jako {user?.fullName ?? '—'}</span>
        {/* Pełne wyjaśnienie tylko od sm w górę — na telefonie zajmowało pół ekranu, a sam
            nagłówek wystarczy, żeby nie pomylić kont. */}
        <span className="hidden sm:inline text-amber-800"> ({user?.login}) · widzisz portal z jego
          uprawnieniami. Zmiany zapiszą się na jego konto, a audyt odnotuje, że wykonał je
          {' '}{impersonation.adminFullName}.</span>
      </div>
      {blad && <div className="text-[12px] text-red-700 w-full sm:w-auto">{blad}</div>}
      <button type="button" onClick={() => void wroc()} disabled={wychodze}
              className="btn btn-sm bg-amber-800 text-white hover:bg-amber-900 shrink-0">
        <Icon name="logout" /> {wychodze ? 'Wracam…' : 'Wróć na swoje konto'}
      </button>
    </div>
  );
}
